import React from 'react'

const YourSessions = () => {
  return (
    <div>YourSessions</div>
  )
}

export default YourSessions